"use client";
import {
  useMenuStore
} from "../__chunks/MRTXKBQF.js";
import {
  MenuContextProvider
} from "../__chunks/B2J376ND.js";
import "../__chunks/62UHHO2X.js";
import "../__chunks/VEVQD5MH.js";
import "../__chunks/4CMBR7SL.js";
import "../__chunks/C3IKGW5T.js";
import "../__chunks/P7GR5CS5.js";
import "../__chunks/VDHZ5F7K.js";
import "../__chunks/EM5CXX6A.js";
import "../__chunks/MTZPJQMC.js";
import "../__chunks/RS7LB2H4.js";
import "../__chunks/S6EF7IVO.js";
import "../__chunks/LMDWO4NN.js";
import "../__chunks/FTXTWCCT.js";
import "../__chunks/O2PQ2652.js";
import "../__chunks/BM6PGYQY.js";
import "../__chunks/WYCIER3C.js";
import "../__chunks/YV4JVR4I.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/menu/menu-provider.tsx
import { jsx } from "react/jsx-runtime";
function MenuProvider(props = {}) {
  const store = useMenuStore(props);
  return /* @__PURE__ */ jsx(MenuContextProvider, { value: store, children: props.children });
}
export {
  MenuProvider
};
